package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_06_16_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Shail curious about our mission. Goram discourages questions and suggests that they not travel alone. Boat 1: Falorn + Bigs + Goram + Tuesday Boat 2: Shail + Dworlan Boat 3: Dirk + Caper + Annette The cave is echo-y. Lots of stalagtites. Moving faster than walking. Lights quickly disappears. Annette uses radiant weapon to light the way. River is heading north. We are dropping elevation. 4pm-ish our heroes come across an area where they could pull their boats over. They decide to stop for the night. Our heroes see an opening 35 feet wide. East to west river, opening to the north. There is no light but an unclean oder in the air. They hear water echoing the cave. Dirk sees some creatures moving in the back of the cavern. Something is being spoken in a language he does not know. Creatures are tied to the abyssal plane. Yuant-ti are serpent-like. Fights happen. Dwarves are huddled in the back at the campfire.")
    }
}
